import KYC from "./Kyc";
import Logout from "./LogOut";
import Profile from "./Profile";
import Reports from "./Reports";
import UserName from "./UserName";
import Wallet from "./Wallet";
import { Modal } from "antd";
import React, { useState, useEffect } from "react";
import Button from "../Button";
import "./style.css";
import Wishlist from "./Wishlist";
import { getUserProfile } from "../../../utils/API/getUserProfileAPI";

const DropDownModal = () => {
  const [open, setOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const showModal = () => {
    setOpen(true);
  };

  const onCancel = () => {
    setOpen(false);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getUserProfile();
        if (response.success) {
          setUserData(response.data);
        } else {
          console.error("Failed to fetch user profile");
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  return (
    <>
      <Button
        varient="secondaryxl"
        borderColor="black"
        className="w-full text-sm justify-center px-0 py-0  text-blue-800  bg-none sm:w-auto "
        onClick={showModal}
      >
        <div className="w-full">
          {loading ? (
            <div className="mini-photo-wrapper ml-4 my-3  w-9 h-9 bg-gray-200 rounded-full"></div>
          ) : (
            <a className="mini-photo-wrapper">
              <img
                className=" ml-4 my-3 mini-photo rounded-full w-9 h-9"
                src={userData?.profile_image || "/images/user.svg"}
                alt="User"
              />
            </a>
          )}
        </div>
      </Button>
      <Modal
        center
        closeIcon={false}
        open={open}
        footer={null}
        onCancel={onCancel}
        width={186}
        className={
          "drop-down fixed top-14 right-4 p-0 rounded-3xl overflow-hidden rounded-tr-none shadow-lg"
        }
      >
        <div className="min-h-[230px] cursor-pointer overflow-hidden">
          <UserName />
          <hr />
          <Profile onCancel={onCancel} />
          <KYC onCancel={onCancel} />
          <Wallet onCancel={onCancel} />
          <Wishlist onCancel={onCancel} />
          <Reports onCancel={onCancel} />
          <Logout onCancel={onCancel} />
        </div>
      </Modal>
    </>
  );
};
export default DropDownModal;
